module.exports = __webpack_public_path__ + "static/media/low-vision.0d03f10b.svg";